import React, { useContext } from 'react';

import { AuthContext } from 'contexts';
import { buildFullName } from 'utils';
import ContactItemLayout from './ContactItemLayout';
import { BrokerageUser } from './types';

type ContactClientItemProps = {
  user: BrokerageUser;
};

const ContactClientItem: React.FC<ContactClientItemProps> = ({ user }) => {
  const { auth } = useContext(AuthContext);
  const { firstName, lastName, location } = user;
  const fullName = buildFullName(firstName, lastName);
  const locationIndex = Number(location);

  return (
    <ContactItemLayout
      avatarUser={user}
      mainText={fullName}
      subTextOne={auth.org.locations[locationIndex].name}
    />
  );
};

export default ContactClientItem;
